import * as React from 'react';
import { Button } from 'components';
import { FilterList } from '@mui/icons-material';
import { TProductsFiltersButton } from './ProductsFiltersButton.types';
import { getSelectedProductFiltersCount } from 'utils/product';
import './ProductsFiltersButton.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const ProductsFiltersButton: TProductsFiltersButton = ({
  onClick,
  selectedFilters,
  filters,
}) => {
  const localize = useLocalize();
  const selectedFiltersCount = React.useMemo(
    () => getSelectedProductFiltersCount(selectedFilters, filters),
    [selectedFilters, filters]
  );

  return (
    <Button
      variant="outlined"
      startIcon={<FilterList />}
      onClick={onClick}
      className="products-filters-button"
    >
      {localize('products.filters.button')}
      {selectedFiltersCount > 0 && (
        <span className="products-filters-button__count">
          {selectedFiltersCount}
        </span>
      )}
    </Button>
  );
};
